export enum CreateProductModalProps {
  CREATE_HEADING = 'Create Product',
  UPDATE_HEADING = 'Update Product',
  HEADING = 'Product',
  IMAGE_ALT = 'Carbon one',
  PAGE_TITLE = 'Company details',
  BUTTON_LABEL_SUBMIT = 'Continue',
  BUTTON_LABEL_BACK = 'Back',
  MODAL_WIDTH = 725,
  USER_DETAILS = 'userDetails',
  ON_CHANGE = 'onChange',
  CREATE_BRAND = 'New Brand',
  CREATE_PROCESSING_FACILITY = 'New Processing Facility',
  ADD_REPORTING_YEAR = 'Add New Reporting Year',
}

export enum FileTypes {
  SVG = 'image/svg+xml',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export enum ImageUploadProps {
  ERROR_MESSAGE_SIZE = 'Image must smaller than 2MB!',
  ERROR_MESSAGE_FORMAT = 'You can only upload JPG/PNG file!',
  IMAGE_REQUIRED = 'Please select image',
  ICON_ALT = 'camera-icon',
  NAME = 'avatar',
  FIELD_NAME = 'image',
  LIST_TYPE = 'picture-card',
  ACTION_URL = 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
}
export enum ImageUploadStatus {
  COMPLETED = 'done',
  UPLOADING = 'uploading',
}

export enum FieldProps {
  SIZE_BIG = 'big',
  SIZE_EXTRA_BIG = 'extrabig',
  SIZE_SMALL = 'small',
  SIZE_MEDIUM = 'medium',
  PRODUCT_NAME = 'productName',
  DESCRIPTION = 'description',
  Desc = 'Description ',
  Prod_Description = 'Product Description',
  PRODUCT_NAME_PLACEHOLDER = 'Product Name',
  BRAND = 'brand',
  BRAND_PLACEHOLDER = 'Select Brand',
  NET_WEIGHT = 'productNetWeight',
  NET_WEIGHT_PLACEHOLDER = 'Product net weight or volume',
  UNIT = 'ml',
  UNIT_PLACEHOLDER = 'Unit',
  GROSS_WEIGHT = 'productGrossWeight',
  GROSS_WEIGHT_PLACEHOLDER = 'Enter weight in grams',
  GROSS_WEIGHT_LABEL = 'Product gross weight (g) (Including packaging)',
  TEMPERATURE_CONTROL = 'temperatureControl',
  TEMPERATURE_CONTROL_PLACEHOLDER = 'Temperature control',
  PERIOD_PRODUCTION = 'reportingPeriodProduction',
  PERIOD_PRODUCT_PLACEHOLDER = 'Reporting period production (units)',
  PERCENTAGE_COST = 'percentageProcessingFacilityCostGood',
  PERCENTAGE_PLACEHOLDER = 'Percentage of processing facility cost of goods sold',
  REPORTING_PERIOD = 'reportingPeriod',
  REPORTING_PERIOD_PLACEHOLDER = 'Choose reporting period',
  REPORTING_YEAR = 'reportingYear',
  REPORTING_YEAR_PLACEHOLDER = 'Choose reporting year',
  PROCESSING_FACILITY = 'processingFacility',
  PROCESSING_FACILITY_PLACEHOLDER = 'Processing facility',
  DENSITY = 'productDensity',
  DENSITY_PLACEHOLDER = 'Density of the Product',
}

export enum CreateProductModalButtonLabels {
  CREATE = 'Create',
  UPDATE = 'Update',
  CANCEL = 'Cancel',
}

export enum FieldProps {}

export enum ValidationSchema {
  ERROR_MESSAGE = 'Required',
  INTEGER = 'Only integers are accepted',
  NUMBER = 'Please use number only',
  DATE = 'Enter a valid date',
  MIN = 'Value must be greater than or equal to 1',
  MAX = 'Value must be less than or equal to 100',
  MAX_WORDS = 'Description must be at most 100 words',
}

export enum CreateProductFieldKeys {
  BRAND_ID = 'brand_id',
  DENSITY = 'density',
  DESCRIPTION = 'description',
  GROSS_WEIGHT = 'gross_weight',
  NAME = 'name',
  NET_WEIGHT = 'net_weight',
  NET_WEIGHT_UNIT = 'net_weight_unit',
  PROCESSING_FACILITY_COST_PERCENTAGE = 'processing_facility_cost_percentage',
  PROCESSING_FACILITY_ID = 'processing_facility_id',
  REPORTING_YEAR = 'reporting_year',
  REPORTING_PERIOD_UNITS = 'reporting_period_units',
  TEMPERATURE_CONTROL = 'temperature_control',
}
